<template>
    <v-container fluid class="my-0 px-0  py-0">
        <q-agency-building-submenu></q-agency-building-submenu>
        <!-- Charts-->
        <div class="mx-5 q-sticky-buffer">
            <v-progress-linear color="primary" indeterminate v-if="agent == null"></v-progress-linear>
            <div v-if="agent && typeof agent.AgentID == 'undefined'">
                Whooops! This agent exists but their data is incomplete!
                <q-agent-management-menu :agent="agent" v-on:refresh="reset()"></q-agent-management-menu>
            </div>
            <div v-else-if="agent">
                <v-row class="d-inline-flex mt-2 pb-4">
                    <div>
                        <q-agent-management-menu :agent="agent" v-on:refresh="reset()"></q-agent-management-menu>
                    </div>
                    <div>
                        <v-badge color="blue" :content="agent.ContractLevel">
                            <h5> {{ agent.AgentName }}</h5>
                        </v-badge>
                        <div class="agent-title ">
                            <p>{{ agent.Division }} - {{ agent.LeadershipLevel }}</p>
                        </div>
                    </div>
                    <div>
                        <v-chip v-if="agent.Status == 'Active'" class=" ml-7" color="primary" text-color="white">{{ agent.Status }}</v-chip>
                        <v-chip v-else class=" ml-7" color="warning" text-color="white">{{ agent.Status }}</v-chip>
                    </div>
                </v-row>
                <QTabs dark>
                    <v-tab @click="logTabActivty('Profile')">Profile</v-tab>
                    <v-tab @click="logTabActivty('Licensing')">Licensing</v-tab>
                    <v-tab v-if="tenantHasFeature('Support', agent.TenantID) && !user.demo_mode" @click="logTabActivty('Support')">Support</v-tab>
                    <v-tab v-if="tenantHasFeature('Stats', agent.TenantID) && !user.demo_mode" @click="logTabActivty('Stats')">Stats</v-tab>
                    <v-tab v-if="tenantHasFeature('Leads', agent.TenantID)" @click="logTabActivty('Leads')">Leads</v-tab>
                    <v-tab v-if="tenantHasFeature('Stats', agent.TenantID)" @click="logTabActivty('Policies')">Policies</v-tab>
                    <v-tab v-if="tenantHasFeature('CrossSaleCommissions', agent.TenantID)" @click="logTabActivty('Commission')">Commission</v-tab>
                    <v-tab @click="logTabActivty('Recruiting')">Recruiting</v-tab>
                    <v-tab @click="logTabActivty('Documents')">Documents</v-tab>
                    <v-tab @click="logTabActivty('Notes')">
                        <v-badge v-if="note_count > 0" color="yellow lighten-4 black--text" :content="note_count">Notes</v-badge>
                        <span v-else>Notes</span>
                    </v-tab>
                    <v-tab-item class="profile-info">
                        <v-row class="text-left pa-3 cms" wrap>
                            <v-col cols="12" lg="4" class="px-6">
                                <QUserBadges :agent="agent" />
                                <div v-if="agent.Avatar" class="agent_profile_photo">
                                    <v-img :aspect-ratio="1" :src="agent.Avatar"></v-img>
                                </div>
                                <div class="mt-5">
                                    <v-list>
                                        <v-list-item v-if="agent.Status == 'Terminated'">
                                            <v-list-item-icon class="text-center" style="width:30px;">
                                                <v-icon color="primary" style="margin:0 auto;">fas fa-ban</v-icon>
                                            </v-list-item-icon>
                                            <v-list-item-content>
                                                <v-list-item-title>
                                                    {{ agent.Status }} : {{ agent.TerminationReason }}
                                                </v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                        <v-divider v-if="agent.Status == 'Terminated'"></v-divider>
                                        <v-list-item>
                                            <v-list-item-icon class="text-center" style="width:30px;">
                                                <v-icon color="primary" style="margin:0 auto;">fas fa-envelope</v-icon>
                                            </v-list-item-icon>
                                            <v-list-item-content>
                                                <v-list-item-title>
                                                    <a :href="'mailto:' + agent.AgentEmail">{{ agent.AgentEmail }}</a>
                                                </v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                        <v-divider></v-divider>
                                        <v-list-item>
                                            <v-list-item-icon class="text-center" style="width:30px;">
                                                <v-icon color="primary" style="margin:0 auto;">fas fa-phone</v-icon>
                                            </v-list-item-icon>
                                            <v-list-item-content>
                                                <v-list-item-title>
                                                    <a :href="'tel:' + agent.AgentPhone">{{ agent.AgentPhone }}</a><br>
                                                    <span v-if="agent.BusinessPhone">Business : <a :href="'tel:' + agent.BusinessPhone">{{ agent.BusinessPhone }}</a><br></span>
                                                    <span v-if="agent.CellPhone">Cell : <a :href="'tel:' + agent.CellPhone">{{ agent.CellPhone }}</a></span>
                                                </v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                        <v-divider></v-divider>
                                        <v-list-item>
                                            <v-list-item-icon class="text-center" style="width:30px;">
                                                <v-icon color="primary" style="margin:0 auto;">fas fa-address-card</v-icon>
                                            </v-list-item-icon>
                                            <v-list-item-content>
                                                <v-list-item-title>
                                                    {{ agent.StreetAddress }}<br>
                                                    {{ agent.City }} {{ agent.State }}, {{ agent.Zip }}<br>
                                                    <span v-if="agent.County">County : {{agent.County}}</span>
                                                </v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                        <v-divider></v-divider>
                                        <v-list-item>
                                            <v-list-item-icon>
                                                <v-icon color="primary" style="margin:0 auto;">fas fa-calendar-check</v-icon>
                                            </v-list-item-icon>
                                            <v-list-item-content>
                                                <v-list-item-title v-if="agent.LastLoginDate" class="">
                                                    <div style="display:inline-block; width:150px; "><b>Last HQ Login:</b></div>
                                                    <div style="display:inline-block; width:150px; ">{{ formatDateCalendarWithYear(agent.LastLoginDate) }}</div>
                                                </v-list-item-title>
                                                <v-list-item-title v-if="agent.LastActivityDate" class="pt-2">
                                                    <div style="display:inline-block; width:150px; "><b>Last Opt! Login:</b></div>
                                                    <div style="display:inline-block; width:150px; "> {{ formatDateCalendarWithYear(agent.LastActivityDate) }}</div>
                                                </v-list-item-title>
                                                <v-list-item-title v-if="agent.ContractStartDt" class="">
                                                    <div style="display:inline-block; width:150px; "><b>Start Date:</b></div>
                                                    <div style="display:inline-block; width:150px; ">{{ formatDateCalendarWithYear(agent.ContractStartDt) }}</div>
                                                </v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-list>
                                </div>
                            </v-col>
                            <v-col cols="12" lg="4" class="px-6">
                                <v-alert type="warning" v-if="!agent.IsFullyLicensed && agent.LeadershipLevel !== 'Wholesale Agency'">
                                    This agent is not fully licensed!
                                </v-alert>
                                <v-list style="">
                                    <v-list-item>
                                        <v-list-item-icon class="text-center" style="width:30px;">
                                            <v-icon color="primary" style="margin:0 auto;">fas fa-user</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                <div class="overline">Agent Code:</div>
                                                <div>{{ agent.AgentCode }} </div>
                                                <div class="overline" style="padding-top:1em;">Agent NPN#: </div>
                                                <div>{{ agent.NPN }}</div>
                                                <div class="overline" style="padding-top:1em;">Opt ID:</div>
                                                <div>{{ agent.OptID }}</div>
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-divider v-if="agent.DoingBusinessAsName || agent.DoingBusinessAsNPN"></v-divider>
                                    <v-list-item v-if="agent.DoingBusinessAsName || agent.DoingBusinessAsNPN">
                                        <v-list-item-icon class="text-center" style="width:30px;">
                                            <v-icon color="primary" style="margin:0 auto;">fas fa-briefcase</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                <div v-if="agent.DoingBusinessAsName" class="overline">DBA: </div>
                                                <div>{{ agent.DoingBusinessAsName }}</div>
                                                <div v-if="agent.DoingBusinessAsNPN" class="overline" style="padding-top:1em;">DBA NPN #: </div>
                                                <div>{{ agent.DoingBusinessAsNPN }}</div>
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-divider></v-divider>
                                    <v-list-item>
                                        <v-list-item-icon>
                                            <v-icon color="primary" style="margin:0 auto;">fas fa-users</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title class="overline">Memberships and subscriptions</v-list-item-title>
                                            <v-list-item-subtitle>
                                                <v-list dense>
                                                    <v-list-item v-if="agent.IsAdvisoryBoardMember" class="body-2">
                                                        <v-icon color="primary">far fa-check-circle</v-icon>
                                                        <v-list-item-content class="pl-3">
                                                            Advisory Board Member
                                                        </v-list-item-content>
                                                    </v-list-item>
                                                    <v-list-item v-if="agent.IsOwnerCircleMember" class="body-2 ">
                                                        <v-icon color="primary">far fa-check-circle</v-icon>
                                                        <v-list-item-content class="pl-3">Owners Circle Member</v-list-item-content>
                                                    </v-list-item>
                                                    <v-list-item v-if="agent.HasManagerAccess" class="body-2">
                                                        <v-icon color="primary">far fa-check-circle</v-icon>
                                                        <v-list-item-content class="pl-3">Virtual Assistant</v-list-item-content>
                                                    </v-list-item>
                                                    <v-list-item v-if="agent.PCSParticipant" class="body-2 pt-2">
                                                        <v-icon color="primary">far fa-check-circle</v-icon>
                                                        <v-list-item-content class="pl-3">PCS Participant <br />
                                                            Start Date: {{ agent.PCSStartDate }}</v-list-item-content>
                                                    </v-list-item>
                                                    <v-list-item v-if="agent.PCSAgentInd" class="body-2 pt-2">
                                                        <v-icon color="primary">far fa-check-circle</v-icon>
                                                        <v-list-item-content class="pl-3">PCS Agent<br />
                                                            {{ agent.PCSAgentStartDate }} - {{ agent.PCSAgentEndDate }}</v-list-item-content>
                                                    </v-list-item>
                                                    <v-list-item v-if="agent.DFLCertifiedInd" class="body-2 pt-2">
                                                        <v-icon color="primary">far fa-check-circle</v-icon>
                                                        <v-list-item-content class="pl-3">DFL Certified</v-list-item-content>
                                                    </v-list-item>
                                                    <v-list-item v-if="agent.AnnuityCertifiedInd" class="body-2 pt-2">
                                                        <v-icon color="primary">far fa-check-circle</v-icon>
                                                        <v-list-item-content class="pl-3">Annuity Certified</v-list-item-content>
                                                    </v-list-item>
                                                    <v-list-item v-if="agent.IULCertifiedInd" class="body-2 pt-2">
                                                        <v-icon color="primary">far fa-check-circle</v-icon>
                                                        <v-list-item-content class="pl-3">IUL Certified</v-list-item-content>
                                                    </v-list-item>
                                                    <v-list-item v-if="agent.IBCCertifiedInd" class="body-2 pt-2">
                                                        <v-icon color="primary">far fa-check-circle</v-icon>
                                                        <v-list-item-content class="pl-3">IBC Certified</v-list-item-content>
                                                    </v-list-item>
                                                    <v-list-item v-if="agent.SeasonedNewAgentInd" class="body-2 pt-2">
                                                        <v-icon color="primary">far fa-check-circle</v-icon>
                                                        <v-list-item-content class="pl-3">Seasoned New Agent</v-list-item-content>
                                                    </v-list-item>
                                                </v-list>
                                            </v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-col>
                            <v-col cols="12" lg="4" class="px-6">
                                <q-agent-upline :agent="agent"></q-agent-upline>
                            </v-col>
                            <v-col cols="12">
                                <q-agent-sticky-notes v-on:notes="updateNoteCount" :agent="agent"></q-agent-sticky-notes>
                            </v-col>
                        </v-row>
                    </v-tab-item>
                    <v-tab-item class="licensing-info">
                        <div class="pa-4">
                            <h2>Licensing</h2>
                            <q-agent-licensing :agent="agent"></q-agent-licensing>
                        </div>
                    </v-tab-item>
                    <v-tab-item v-if="tenantHasFeature('Support', agent.TenantID) && !user.demo_mode" class="support">
                        <div class="pa-4">
                            <q-agent-support-tickets-data-table :agent="agent" title="Support Tickets"></q-agent-support-tickets-data-table>
                        </div>
                    </v-tab-item>
                    <v-tab-item class="stats" v-if="tenantHasFeature('Stats', agent.TenantID) && !user.demo_mode">
                        <QTabs class="q-text-left" background-color="q_symm_blue" dark>
                            <v-tab v-if="tenantHasFeature('Scorecards.Submitted', agent.TenantID) || tenantHasFeature('Scorecards.Placed', agent.TenantID)">
                                Production Scorecard
                            </v-tab>
                            <v-tab v-if="tenantHasFeature('Scorecards.Recruiting', agent.TenantID)">
                                Recruiting Scorecard
                            </v-tab>
                            <v-tab v-if="tenantHasFeature('Leads', agent.TenantID)">
                                Leads Scorecard
                            </v-tab>
                            <v-tab v-if="tenantHasFeature('Scorecards.Events', agent.TenantID)">
                                Events Scorecard
                            </v-tab>
                            <v-tab v-if="tenantHasFeature('PCS', agent.TenantID)">
                                QuilityRx Scorecard
                            </v-tab>
                            <v-tab-item class="pa-2" v-if="tenantHasFeature('Scorecards.Submitted', agent.TenantID) || tenantHasFeature('Scorecards.Placed', agent.TenantID)">
                                <agent-score-cards-new-business :show-submenu="false" :allowAgentLookup="false"></agent-score-cards-new-business>
                            </v-tab-item>
                            <v-tab-item v-if="tenantHasFeature('Scorecards.Recruiting', agent.TenantID)" class="pa-2">
                                <score-cards-recruiting :show-submenu="false" :allowAgentLookup="false"></score-cards-recruiting>
                            </v-tab-item>
                            <v-tab-item class="pa-2" v-if="tenantHasFeature('Leads', agent.TenantID)">
                                <score-cards-leads :show-submenu="false" :allowAgentLookup="false"></score-cards-leads>
                            </v-tab-item>
                            <v-tab-item class="pa-2" v-if="tenantHasFeature('Scorecards.Events', agent.TenantID)">
                                <score-cards-events :show-submenu="false" :allowAgentLookup="false"></score-cards-events>
                            </v-tab-item>
                            <v-tab-item class="pa-2" v-if="tenantHasFeature('PCS', agent.TenantID)">
                                <score-card-quility-rx :show-submenu="false" :allowAgentLookup="false"></score-card-quility-rx>
                            </v-tab-item>
                        </QTabs>
                        <!--<q-downline-stats :agent="agent" v-if="agent && agent.IsAgencyOwner"></q-downline-stats>//-->
                    </v-tab-item>
                    <v-tab-item class="leads" v-if="tenantHasFeature('Leads', agent.TenantID)">
                        <QTabs class="q-text-left" background-color="q_symm_blue" dark>
                            <v-tab>
                                Leads
                            </v-tab>
                            <v-tab>
                                Digital Lead Orders
                            </v-tab>
                            <v-tab>
                                Recruiting Lead Orders
                            </v-tab>
                            <v-tab-item class="pa-2">
                                <q-lead-data-table :agent="agent" :rows="10" title="Leads"></q-lead-data-table>
                            </v-tab-item>
                            <v-tab-item class="pa-2">
                                <q-dx-lead-order-data-table :no-actions="true" :lead-types="['DX']" ref="lead_order_datatable" :agent-code="agent.AgentCode" title="DX Lead Orders" key="agent_detail_dx_lead_orders"></q-dx-lead-order-data-table>
                            </v-tab-item>
                            <v-tab-item class="pa-2">
                                <q-dx-lead-order-data-table :no-actions="true" :lead-types="['Recruiting']" ref="lead_order_datatable" :agent-code="agent.AgentCode" title="Recruiting Lead Orders" key="agent_detail_recruiting_lead_orders"></q-dx-lead-order-data-table>
                            </v-tab-item>
                        </QTabs>
                    </v-tab-item>
                    <v-tab-item class="policies" v-if="tenantHasFeature('Stats', agent.TenantID)">
                        <QTabs class="q-text-left" background-color="q_symm_blue" dark>
                            <v-tab v-if="tenantHasFeature('Scorecards.Submitted', agent.TenantID)">
                                Submitted
                            </v-tab>
                            <v-tab v-if="tenantHasFeature('Scorecards.Pending', agent.TenantID)">
                                Pending
                            </v-tab>
                            <v-tab v-if="tenantHasFeature('Scorecards.Placed', agent.TenantID)">
                                Placed
                            </v-tab>
                            <v-tab v-if="tenantHasFeature('Scorecards.Closed', agent.TenantID)">
                                Closed
                            </v-tab>
                            <v-tab-item class="pa-2" v-if="tenantHasFeature('Scorecards.Submitted', agent.TenantID)">
                                <q-submitted-policy-data-table :agent="agent" :rows="25" title="Submitted Policies" stat-type="PersonalProduction"></q-submitted-policy-data-table>
                            </v-tab-item>
                            <v-tab-item class="pa-2" v-if="tenantHasFeature('Scorecards.Pending', agent.TenantID)">
                                <q-pending-policy-data-table :agent="agent" :rows="25" title="Pending Policies" stat-type="PersonalProduction"></q-pending-policy-data-table>
                            </v-tab-item>
                            <v-tab-item class="pa-2" v-if="tenantHasFeature('Scorecards.Placed', agent.TenantID)">
                                <q-placed-policy-data-table :agent="agent" :rows="25" title="Placed Policies" stat-type="PersonalProduction"></q-placed-policy-data-table>
                            </v-tab-item>
                            <v-tab-item class="pa-2" v-if="tenantHasFeature('Scorecards.Closed', agent.TenantID)">
                                <q-closed-policy-data-table :agent="agent" :rows="25" title="Closed Policies" stat-type="PersonalProduction"></q-closed-policy-data-table>
                            </v-tab-item>
                        </QTabs>
                    </v-tab-item>
                    <v-tab-item class="commission" v-if="tenantHasFeature('CrossSaleCommissions', agent.TenantID)">
                        <q-agent-commission-datatable key="AgentDetailDXLeadOrders" :agent="agent" title="PCS Bonus"></q-agent-commission-datatable>
                    </v-tab-item>
                    <v-tab-item class="recruiting">
                        <QTabs class="q-text-left" background-color="q_symm_blue" dark>
                            <v-tab>
                                <span v-if="agent.LeadershipLevel != 'Agency Owner'">Total Agency Directory</span>
                                <span v-else>Base Shop Directory</span>
                            </v-tab>
                            <v-tab v-if="tenantHasFeature('Onboarding', agent.TenantID)">Onboarding Stats</v-tab>
                            <v-tab>Hierarchy</v-tab>
                            <v-tab-item class="pa-2">
                                <q-agent-downline-directory-table :rows="20" :show-all="true" :title="agent.AgentName + ' Agency'" :agent="agent"></q-agent-downline-directory-table>
                            </v-tab-item>
                            <v-tab-item class="pa-2" v-if="tenantHasFeature('Onboarding', agent.TenantID)">
                                <h3>Onboarding Stats Coming Soon!</h3>
                            </v-tab-item>
                            <v-tab-item class="pa-2">
                                <q-agency-structure-chart :agent="agent"></q-agency-structure-chart>
                            </v-tab-item>
                        </QTabs>
                        <div class="pa-4">
                        </div>
                    </v-tab-item>
                    <v-tab-item class="documents">
                        <div class="pa-4">
                            <q-agent-documents :agent="agent"></q-agent-documents>
                        </div>
                    </v-tab-item>
                    <v-tab-item class="licensing-info">
                        <div class="pa-4">
                            <q-agent-notes :agent="agent"></q-agent-notes>
                        </div>
                    </v-tab-item>
                    <v-tab-item v-if="hasRole('SuperAdmin')" class="raw-data">
                        <v-row wrap>
                            <v-col cols="3" v-for="(attr, key) in agent" :key="key">
                                <strong>{{ key }} :<br> </strong> {{attr}}
                            </v-col>
                        </v-row>
                    </v-tab-item>
                </QTabs>
            </div>
        </div>
    </v-container>
</template>
<script>
import QAgencyStructureChart from '@/components/charts/QAgencyStructureChart.vue'
import QAgencyBuildingSubmenu from '@/components/navigation/Submenus/QAgencyBuildingSubmenu.vue';
import QDownlineStats from '@/components/stats/QDownlineStats.vue';
import QuilityAPI from '@/store/API/QuilityAPI.js'
import Agent from '@/store/Models/Agent'
import QAgentStats from '@/components/stats/QAgentStats.vue';
import QBaseshopStats from '@/components/stats/QBaseshopStats.vue';
import QAgentUpline from '@/components/lists/QAgentUpline.vue';
import QPersonalProductionStats from '@/components/stats/QPersonalProductionStats.vue';
import QAgentDirectoryTable from '@/components/datatables/QAgentDirectoryTable.vue';
import QAgentLicensing from '@/components/utils/QAgentLicensing.vue';
import QAgentDownlineDirectoryTable from '@/components/datatables/QAgentDownlineDirectoryTable.vue';
import QAgentManagementMenu from '@/components/navigation/QAgentManagementMenu.vue';
import QLeaderboardDataTableWrapper from '@/components/datatables/QLeaderboardDataTableWrapper.vue'
import QAgentDocuments from '@/components/agent_admin/QAgentDocuments.vue'
import QAgentSupportTicketsDataTable from '@/components/datatables/QAgentSupportTicketsDataTable.vue'
import QAgentNotes from '@/components/agent_admin/QAgentNotes.vue'
import QAgentStickyNotes from '@/components/agent_admin/QAgentStickyNotes.vue'
import QLeadDataTable from '@/components/datatables/QLeadDataTable.vue';
import QSubmittedPolicyDataTable from '@/components/datatables/QSubmittedPolicyDataTable.vue';
import QPendingPolicyDataTable from '@/components/datatables/QPendingPolicyDataTable.vue';
import QPlacedPolicyDataTable from '@/components/datatables/QPlacedPolicyDataTable.vue';
import QClosedPolicyDataTable from '@/components/datatables/QClosedPolicyDataTable.vue';
import QAgentCommissionDatatable from '@/components/datatables/QAgentCommissionDatatable.vue'
import AgentScoreCardsNewBusiness from '@/views/MyStats/AgentScoreCards_NewBusiness.vue'
import ScoreCardsLeads from '@/views/MyStats/ScoreCards_Leads.vue'
import ScoreCardsRecruiting from '@/views/MyStats/ScoreCards_Recruiting.vue'
import ScoreCardsEvents from '@/components/stats/scorecards/QScoreCards_EventsAll.vue'
import ScoreCardQuilityRx from '@/views/MyStats/QScoreCards_QuilityRx.vue';
import QDxLeadOrderDataTable from '@/components/datatables/LeadOrders/QDxLeadOrderDataTable.vue'
import QTabs from '../../../components/navigation/QTabs.vue'
import QUserBadges from '@/components/QUserBadges.vue'

export default {
    name: "AgentDetail",
    data() {
        return {
            agentcode: null,
            agentdownline: {},
            current_agent: null,
            stickyTop: 0,
            date_period: 'monthly',
            editUpline: false,
            note_count: 0,
        };
    },
    mounted: function() {
        this.reset();
    },
    computed: {
        'agent': function() {
            return this.$store.state.entities.agent.currentAgent;
        },
        loading: function() {
            return this.$store.state.entities.agent.loading;
        },
    },
    methods: {
        showAgent(agent) {
            this.current_agent = agent
        },
        reset: function() {
            this.agentcode = this.$route.params.agentcode;
            this.note_count = 0;
            var g = this
            QuilityAPI.getAgent(this.agentcode, ['LeadershipLevel', 'Signature', 'LastLoginDate', 'CurrentSummitBadge']).then(function(json) {}).catch(function(json) {
                if (json.errors == "Page not found") {
                    Agent.commit((state) => {
                        state.loading = false
                        state.currentAgent = { AgentCode: g.agentcode }
                    })
                }
            });
        },
        getDownline: function() {
            return this.recursiveDownline(this.agent.Downline)
        },
        getAgentDownline: function(AgentCode) {
            var g = this
            QuilityAPI.getAgentDownline(AgentCode, [], function(json) {
                g.agentdownline[AgentCode] = json
            });
        },
        recursiveDownline: function(children) {
            var str = ""
            for (var i = 0; i < children.length; i++) {
                str = str + "<a href='/admin/agents/" + children[i].AgentCode + "'>" + children[i].AgentName + "</a><br>";
                if (children[i].Downline == null) continue;
                if (children[i].Downline.length > 0) {
                    str = str + this.recursiveDownline(children[i].Downline);
                }
            }
            return str;
        },
        loadAgent(agentcode) {
            this.$router.push('/admin/agents/' + agentcode)
        },
        updateNoteCount(notes) {
            this.note_count = notes.meta.note_count;
        }
    },
    watch: {
        '$route.params.agentcode': function(newV, oldV) {
            if (typeof newV != 'undefined' && this.agentcode != newV) {
                this.reset();
            }
        },
        '$store.state.entities.agent.currentAgent.NeedsUpdate': function(newV) {
            if (newV === true) {
                this.reset();
            }
        }
    },
    components: {
        QAgencyBuildingSubmenu,
        QAgentStats,
        QDownlineStats,
        QPersonalProductionStats,
        QBaseshopStats,
        QAgentUpline,
        QAgencyStructureChart,
        QAgentDirectoryTable,
        QAgentLicensing,
        QAgentDownlineDirectoryTable,
        QAgentManagementMenu,
        QLeaderboardDataTableWrapper,
        QAgentDocuments,
        QAgentSupportTicketsDataTable,
        QAgentNotes,
        QAgentStickyNotes,
        QLeadDataTable,
        QAgentCommissionDatatable,
        AgentScoreCardsNewBusiness,
        ScoreCardsLeads,
        ScoreCardsRecruiting,
        ScoreCardsEvents,
        ScoreCardQuilityRx,
        QDxLeadOrderDataTable,
        QTabs,
        QPlacedPolicyDataTable,
        QClosedPolicyDataTable,
        QPendingPolicyDataTable,
        QSubmittedPolicyDataTable,
        QUserBadges,
    }
};
</script>
<style scoped>
blockquote {
    margin-left: 50px;
}
</style>